import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FaIcons from 'react-icons/fa';

const { FaTiktok } = FaIcons;

const Footer = () => {
  const { t, currentLanguage } = useLanguage();

  return (
    <motion.footer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8 }}
      className="bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg border-t border-gray-200/20 dark:border-gray-700/20 py-8"
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center justify-center space-y-6">
          <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3 text-center">
            <h3 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
              {t('appName')}
            </h3>
            
            <span className="hidden md:inline text-gray-300 dark:text-gray-600 font-light text-xl">|</span>
            
            <div className="flex items-center space-x-1 text-gray-600 dark:text-gray-400">
              <span>{t('anAppBy')}</span>
              <motion.a
                href="https://appfred.com"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                className="font-bold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity"
              >
                Appfred
              </motion.a>
            </div>
          </div>

          <div className="flex items-center space-x-6">
            <span className="text-sm text-gray-500 dark:text-gray-500">
              {t('copyright')}
            </span>
            
            <motion.a
              whileHover={{ scale: 1.2, rotate: 5 }}
              whileTap={{ scale: 0.9 }}
              href="https://www.tiktok.com/@alfredmenendez"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-black dark:hover:text-white transition-colors"
            >
              <SafeIcon icon={FaTiktok} className="w-5 h-5" />
            </motion.a>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;